import React, { useState, useEffect } from "react";

import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";
import { NavLink } from "react-router-dom";
import MUIDataTable from "mui-datatables";
//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

//Material UI Icons
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
// Material UI Component
import {
  FormGroup,
  FormLabel,
  FormControl,
  FormHelperText,
  NativeSelect,
  // ListItemText,
  TextField,
  // Checkbox,
  // FormControlLabel,
  // Grid,
  // Select,
  Input,
  InputLabel,
  // MenuItem,
  Modal,
  Backdrop,
  //Fade,
  fade,
  Button,
  Grid,
  Breadcrumbs,
  Typography,
  Fade,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone, FaceRounded } from "@material-ui/icons";
import { get_cookies, isLoggedIn } from "../../../components/Cookies/Cookies";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MessageBox from "../../../components/MessageBox/MessageBox";
const useStyles = makeStyles((theme) => ({
  // modal: {
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "center",
  // },
  button:{
    display:'flex',
    justifyContent:'space-between',
    alignItems:'center',
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",

    margin: "0 auto",
  },
  textField: {
    marginTop: "-15px",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius:8,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "400px",
    maxHeight: "100%",
    overflow: "auto",
  },
}));


const DeleteGlAccount = (props) => {
  const { showModal, data } = props;
  const [posts, setPosts] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(true);
  const [open, setOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const handleModalOpen = () => {
    setModalOpen(true);
  };
  const classes = useStyles();
  const handleModalClose = () => {
    setModalOpen(false);
  };
  const  deleteSupplier = async () => {
        const formData = new FormData();
        formData.append("id", data.id);
        await axios.post(process.env.REACT_APP_API_URL+'delete_gl_accounts_list', formData, {
                headers: {
                        'Content-Type': 'multipart/form-data'
                        }
                }).then(function (res) {
                        showModal('Deleted GL Account ','success');
                        handleModalClose();
                  }).catch(function (error) {
                        showModal('Something went wrong '+ error.message, 'warning');
                        handleModalClose();
                  });
}
  const handleSubmit = (e) => {
        e.preventDefault();

        deleteSupplier();
}
  return (
    <div>
    <Button
      variant="contained"
      onClick={handleModalOpen}
      style={{ backgroundColor: "#f42929", color: "#fff" }}
    >
      Delete
    </Button>
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={modalOpen}
      onClose={handleModalClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={modalOpen}>
        <div className={classes.paper}>
          <h2 id="transition-modal-title">Delete Gl Account</h2>
          <form onSubmit={handleSubmit} className={classes.root}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                Are you sure you want to delete this Gl Account? <br />
              </Grid>
            </Grid>
            <div className={classes.button}>
              <Button
                variant="contained"
                onClick={handleModalClose}
                className={classes.buttonMarginRight}
              >
                Cancel
              </Button>
              <Button type="submit" variant="contained"  style={{backgroundColor:'#f42929', color:'#fff'}}>
                Delete
              </Button>
            </div>
          </form>
        </div>
      </Fade>
    </Modal>
  </div>
  )
}

export default DeleteGlAccount